// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1g9LM","content":"styles_content__2Qsq_"};